namespace Roodik.Game
{
	import ViewBase = Roodik.Core.ViewBase;
	import Slot = dragonBones.Slot;
	import Tween = Roodik.Core.Tween.Tween;
	import Easing = Roodik.Core.Tween.Easing;
	
	export class TileView extends ViewBase
	{
		private _hitArea: Slot;
		private _onDownHandler: () => void;
		private _onOverHandler: () => void;
		private _onOutHandler: () => void;
		private _icon:IconView;
		
		constructor(private _index:number,
		            private _model:ITileModel,
		            private _clickCallBack:(index : number)=>void,
		            private _overCallBack:(model:ITileModel)=>void,
		            private _outCallBack:(model:ITileModel)=>void)
		{
			super("TileView");

			this.visible = false;
			
			this._icon = new IconView(this._model.type);
			this.addChild(this._icon);
			
			this.x = this._model.x;
			this.y = this._model.y;
			
			this._hitArea = this.childByName("hitArea");
			this._hitArea.display.interactive = true;
			this._hitArea.display.buttonMode = true;
			this._onDownHandler = this.onDown.bind(this);
			this._onOverHandler = this.onOver.bind(this);
			this._onOutHandler = this.onOut.bind(this);
			
			this._model.selectedCallBack(this.changeSelection.bind(this));
			this._model.changePositionCallBack(this.changePosition.bind(this));
			this._model.changeTypeCallBack(this.changeType.bind(this));
		}

		public show()
		{
			this.alpha = 0;
			this.visible = true;

			let obj={alpha:this.alpha}
			new Tween(obj)
			.to({alpha:1}, 300)
			.easing(Easing.Quadratic.Out)
			.onUpdate(()=>{
				this.alpha = obj.alpha;
			})
			.onComplete(()=>{
				this.subscribe();
			})
			.start();
		}
		
		private changePosition()
		{
			this.scale.x = this._model.scaleX;
			this.scale.y = this._model.scaleY;

			this.x = this._model.x;
			this.y = this._model.y;
		}

		private changeType()
		{
			let properties = {rotate:this.rotation};
			new Tween(properties)
			.to({rotate:(Math.random() < 0.5 ? 1 : -1)*6.28319}, 150)
			.easing(Easing.Quadratic.Out)
			.onUpdate(()=>{
				this.rotation = properties.rotate;
			})
			.onComplete(function ()
			{
				this.rotation = 0;
			}.bind(this))
			.start();

			this.removeChild(this._icon);
			this._icon.destroy();

			this._icon = new IconView(this._model.type);
			this.addChild(this._icon);
		}
		
		private changeSelection()
		{
			this._hitArea.display.alpha = this._model.selected ? 0.7 : 0;
		}
		
		private subscribe()
		{
			this._hitArea.display.on("mousedown", this._onDownHandler);
			this._hitArea.display.on("mouseover", this._onOverHandler);
			this._hitArea.display.on("mouseout", this._onOutHandler);
			this._hitArea.display.on("touchstart", this._onDownHandler);
			this._hitArea.display.on("touchendoutside", this._onOutHandler);
		}
		
		private unSubscribe()
		{
			this._hitArea.display.off("mousedown", this._onDownHandler);
			this._hitArea.display.off("mouseover", this._onOverHandler);
			this._hitArea.display.off("mouseout", this._onOutHandler);
			this._hitArea.display.off("touchstart", this._onDownHandler);
			this._hitArea.display.off("touchendoutside", this._onOutHandler);
		}

		private onDown(): void
		{
			this._clickCallBack(this._index);
		}
		
		private onOver(): void
		{
			this.scale.x = 1.05;
			this.scale.y = 1.05;

			if (!this._model.selected && this._overCallBack != null)
			{
				this._overCallBack(this._model);
			}
		}
		
		private onOut(): void
		{
			this.scale.x = 1;
			this.scale.y = 1;
			if (!this._model.selected && this._outCallBack != null)
			{
				this._outCallBack(this._model);
			}
		}

		public remove()
		{
			this.onOut();
			this.visible = false
		}
		
		public destroy()
		{
			this._model.destroy();

			this.removeChild(this._icon);
			this._icon.destroy();

			this._outCallBack = null;
			this._clickCallBack = null;
			this.unSubscribe();

			this._onOverHandler = null;
			this._onDownHandler = null;
			this._onOutHandler = null;
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/Board/TileView.ts